import { render } from "./latestProductCard.vue?vue&type=template&id=8726610e&scoped=true"
import script from "./latestProductCard.vue?vue&type=script&lang=js"
export * from "./latestProductCard.vue?vue&type=script&lang=js"

import "./latestProductCard.vue?vue&type=style&index=0&id=8726610e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8726610e"]])

export default __exports__